import React, { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

export const BAR_HEIGHT = 80;

const GlobalStyle = createGlobalStyle`
  body {
    padding-bottom: ${`${BAR_HEIGHT}px`};
  }
`;

const BarWrapper = styled.div<{ zIndex?: number }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.5);
  z-index: ${({ zIndex }) => zIndex || 1700};
`;

type StickyBarProps = {
  children?: boolean | JSX.Element | null;
  zIndex?: number;
  id?: string;
};

export const StickyBarWrapper: FC<StickyBarProps> = ({ id, children, zIndex }) => (
  <>
    <GlobalStyle />
    <BarWrapper id={id} zIndex={zIndex}>
      {children}
    </BarWrapper>
  </>
);
